import { useAuth } from '../auth.tsx';
import { Container } from '../components/Layout.tsx';
import { NorrbottenMap } from '../components/NorrbottenMap.tsx';
import { Card, PageTitle } from '../components/ui.tsx';
import { useTitle } from '../hooks.ts';

export function NorrbottenPage() {
  useTitle('Norrbottenskartan');
  const { user } = useAuth();
  return (
    <Container>
      <PageTitle sub="Länets lärare lär sig om AI tillsammans. Kartan fylls i allt eftersom fler tar intyget.">
        Norrbottenskartan
      </PageTitle>
      <Card>
        <NorrbottenMap highlight={user?.municipality} />
      </Card>
    </Container>
  );
}
